import { Box, Paper, Skeleton, Stack, Divider } from "@mui/material";

const DrawerSkeleton = () => {
  return (
    <Paper sx={{ p: 4 }}>
      <Stack spacing={3}>
        {/* Top controls (Interface / Destination Table / Save) */}
        <Stack direction="row" spacing={4} alignItems="center">
          <Skeleton variant="rounded" width={220} height={36} />
          <Skeleton variant="rounded" width={260} height={36} />
          <Box sx={{ flexGrow: 1 }} />
          <Skeleton variant="rounded" width={80} height={32} />
        </Stack>

        <Divider />

        {/* Row Filtering title */}
        <Skeleton variant="text" width={120} height={28} />

        {/* Activity Date section */}
        <Stack spacing={2}>
          <Skeleton variant="text" width={100} height={22} />

          <Stack direction="row" spacing={2}>
            <Skeleton variant="rounded" width={260} height={36} />
            <Skeleton variant="rounded" width={260} height={36} />
          </Stack>

          <Skeleton variant="text" width={220} height={18} />
        </Stack>

        {/* Optional Fields (collapsed look) */}
        <Skeleton variant="text" width={140} height={22} />

        <Divider />

        {/* Other Settings */}
        <Skeleton variant="text" width={120} height={24} />

        {/* Table header */}
        <Stack direction="row" spacing={2}>
          <Skeleton variant="text" width={180} height={20} />
          <Skeleton variant="text" width={180} height={20} />
          <Skeleton variant="text" width={180} height={20} />
        </Stack>

        {/* Table row */}
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rounded" width={180} height={32} />
          <Skeleton variant="rounded" width={180} height={32} />
          <Skeleton variant="rounded" width={180} height={32} />
        </Stack>

        {/* Add Row */}
        <Skeleton variant="text" width={100} height={22} />

        <Divider />

        {/* Preview section */}
        <Skeleton variant="text" width={90} height={22} />

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Skeleton variant="rounded" width={110} height={32} />
        </Box>
      </Stack>
    </Paper>
  );
};

export default DrawerSkeleton;
